import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { OneLPSsdkParamsContext } from '../../../onelps-sdk-params-context';
import styles from '../../../css/components/common/links/noRegFormLinks.css';
import PropTypes from 'prop-types';
import { getAssetUrl } from '../../../helpers/get-asset-url';

function NoRegFormLinks({
	gameName = 'Game Name',
	betaPhase = '',
	launchPhaseTranslationKey,
}) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const singularLink = onelpsParams.singularLink;

	const { i18n } = useTranslation('translation');
	const betaPhaseString = betaPhase === 'isClosedBeta' ? 'Closed' : 'Open';

	const getNoRegFormText = () => i18n.t(launchPhaseTranslationKey, { gameName: gameName, betaPhaseString: betaPhaseString });

	let productVideo = undefined;

	if (onelpsParams.launchPhase?.productVideo) {
		try {
			productVideo = getAssetUrl() + require(`../../../video/${GAMEID}/${onelpsParams.launchPhase.productVideo}`);
		} catch (error) {
			console.error('Failed to load video:', error);
			productVideo = undefined;
		}
	}

	const isPreregister = betaPhase === 'isPreRegister';

	return (
		<div className={styles.noRegFormContent}>
			{launchPhaseTranslationKey && <p>
				<Trans
					i18nKey={'translation:' + launchPhaseTranslationKey}
					values={{ gameName, betaPhaseString }}>
					{getNoRegFormText()}
				</Trans>
			</p>
			}
			{isPreregister ? (
				<img
					src={getAssetUrl() + require('../../../img/' + GAMEID + '/launchPhases/' + onelpsParams.launchPhase?.preRegisterQRCodeSrc)}
					alt="QR Code"
					className={styles.qrCodeImage}
				/>
			) : (
				<>
					{productVideo && (
						<video
							width="300"
							loop="loop"
							autoPlay
							muted="muted"
							className={styles.productVideo}
						>
							<source
								src={productVideo}
								type="video/mp4"
							/>
						</video>
					)}
				</>
			)}

			<ul>
				<li>
					<a
						href={singularLink}
						className={styles.appAppstoreBadge}
						data-testid='appstoreLink'
						target='_blank'
						rel="noreferrer"
					>
					</a>
				</li>
				<li>
					<a
						href={singularLink}
						className={styles.appPlaystoreBadge}
						data-testid='playstoreLink'
						target='_blank'
						rel="noreferrer"
					>
					</a>
				</li>
			</ul>
		</div>
	);
}

export default NoRegFormLinks;

NoRegFormLinks.propTypes = {
	betaPhase: PropTypes.string,
	gameName: PropTypes.string,
	launchPhaseTranslationKey: PropTypes.string
};